import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Products.css";

const Products = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const products = [
    {
      category: "Organic Spices",
      description: "Premium organic spices sourced from trusted farms across India. Each spice is carefully selected, processed naturally, and packed to preserve its authentic aroma and flavor. From turmeric's golden warmth to cardamom's exotic fragrance, experience purity in every pinch.",
      images: [
        "https://images.pexels.com/photos/256318/pexels-photo-256318.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        "https://images.pexels.com/photos/34086126/pexels-photo-34086126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      ],
      features: [
        "100% Organic & Chemical-Free",
        "Traditional Processing Methods",
        "Rich Aroma & Authentic Flavor",
        "EU-Certified Sources"
      ]
    },
    {
      category: "Millets",
      description: "Ancient grains making a modern comeback. Our millets are sourced from organic farms and are packed with nutrition, fiber, and minerals. Perfect for health-conscious families looking to embrace wholesome, sustainable eating.",
      images: [
        "https://images.unsplash.com/photo-1768729339998-909158957162",
        "https://images.unsplash.com/photo-1651241587503-a874db54a1a7"
      ],
      features: [
        "High in Protein & Fiber",
        "Gluten-Free Natural Grain",
        "Sustainable & Eco-Friendly",
        "Versatile Cooking Options"
      ]
    },
    {
      category: "Fresh Dairy",
      description: "Pure organic dairy from trusted sources. Our dairy products come from farms that prioritize animal welfare and natural feeding practices. Taste the difference that quality and care make in every sip.",
      images: [
        "https://images.unsplash.com/photo-1768850418251-17480117ac9b",
        "https://images.unsplash.com/photo-1635436338433-89747d0ca0ef"
      ],
      features: [
        "From Grass-Fed Animals",
        "No Hormones or Antibiotics",
        "Fresh & Pure",
        "Rich in Natural Nutrients"
      ]
    },
    {
      category: "Raw Honey",
      description: "Unfiltered, unpasteurized honey straight from nature. Golden, pure, and packed with natural enzymes and nutrients. Each jar is a testament to the hard work of bees and our commitment to preserving nature's gifts.",
      images: [
        "https://images.pexels.com/photos/35042439/pexels-photo-35042439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        "https://images.pexels.com/photos/30666803/pexels-photo-30666803.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      ],
      features: [
        "100% Raw & Unprocessed",
        "Rich in Natural Enzymes",
        "No Added Sugars",
        "Pure Golden Goodness"
      ]
    }
  ];

  return (
    <div className="products-page">
      {/* Hero Section */}
      <section className="products-hero">
        <div className="products-hero-overlay"></div>
        <div className="container products-hero-content">
          <h1 className="animate-on-scroll">Our Products</h1>
          <p className="animate-on-scroll">
            Discover our carefully curated selection of organic essentials
          </p>
        </div>
      </section>

      {/* Products Listing */}
      <section className="section products-listing">
        <div className="container">
          {products.map((product, index) => (
            <div 
              key={index} 
              className={`product-detail ${index % 2 === 0 ? '' : 'reverse'} animate-on-scroll`}
            >
              <div className="product-detail-images">
                <div className="main-product-image">
                  <img src={product.images[0]} alt={product.category} />
                </div>
                {product.images[1] && (
                  <div className="secondary-product-image">
                    <img src={product.images[1]} alt={product.category} />
                  </div>
                )}
              </div>
              <div className="product-detail-content">
                <h2>{product.category}</h2>
                <p className="product-description">{product.description}</p>
                <ul className="product-features">
                  {product.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
                <Link to="/contact" className="btn btn-primary">Enquire Now</Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="section products-cta-section">
        <div className="container">
          <div className="products-cta-content animate-on-scroll">
            <h2>Interested in Our Products?</h2>
            <p>Get in touch with us to learn more about our organic essentials and how we can serve your family's needs.</p>
            <Link to="/contact" className="btn btn-primary">Contact Us Today</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
